var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermoMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 -960 960 960",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560.58-652.12v-55.96h295.96v55.96H560.58ZM335.21-149.39q-71.89 0-122.62-50.5-50.74-50.5-50.74-122.53 0-44.62 21.13-82.51 21.14-37.88 58.06-62.38v-249.96q0-39.18 27.38-66.51 27.37-27.33 66.92-27.33t66.81 27.33q27.27 27.33 27.27 66.51v249.96q36.73 24.5 57.96 62.33 21.24 37.83 21.24 82.06 0 72.37-50.73 122.95-50.72 50.58-122.68 50.58Zm-117.4-173.53h234.85q0-28.81-13.4-53.63-13.4-24.82-36.22-41.87l-29.58-22.89v-275.96q0-15.66-11.15-26.77-11.16-11.11-27.14-11.11t-27.07 10.97Q297-733.21 297-717.21v276.4l-29.58 22.39q-23 17.5-36.3 42.18-13.31 24.68-13.31 53.32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermoMin);
export default __webpack_public_path__ + "static/media/termo-min.924e554aeb6f816329dfc614ccd8cf87.svg";
export { ForwardRef as ReactComponent };